import type { NextPage } from "next";
import PublicNavbarLayout from "../../components/layout/PublicNavbarLayout";
import { useCoachPageQuery } from "../../lib/api/sdk";
import HeaderSection from "./HeaderSection";
import CoachSection from "./CoachSection";
import { useRouter } from "next/router";
import PlansSection from "./PlansSection";

const CoachPage: NextPage = () => {
  const { query } = useRouter();
  const CoachPageReq = useCoachPageQuery({
    variables: { id: +(query?.id || 0) },
  });

  return (
    <PublicNavbarLayout isDark>
      <HeaderSection
        data={CoachPageReq.data}
        loading={CoachPageReq.loading}
      />
      <CoachSection
        data={CoachPageReq.data}
        loading={CoachPageReq.loading}
      />
      <PlansSection
        data={CoachPageReq.data}
        loading={CoachPageReq.loading}
      />
    </PublicNavbarLayout>
  );
};

export default CoachPage;
